module.exports = __webpack_public_path__ + "img/tiger.8361a8c5.webp";